import { render, staticRenderFns } from "./LearnerProfileLayout.vue?vue&type=template&id=1301f28f"
import script from "./LearnerProfileLayout.vue?vue&type=script&lang=js"
export * from "./LearnerProfileLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports